/**
 * Footer - 页脚组件
 */
export class Footer {
  constructor(options = {}) {
    this.copyright = options.copyright || `© ${new Date().getFullYear()} 书阁园. All rights reserved.`;
    this.links = options.links || [];
  }

  render() {
    const footer = document.createElement('footer');
    footer.className = 'footer';
    footer.innerHTML = `
      <div class="container">
        <div class="flex flex--between" style="padding: var(--space-8) 0; flex-wrap:wrap; gap:var(--space-4);">
          <p class="text-muted">${this.copyright}</p>
          <div class="flex" style="gap:var(--space-6);">
            ${this.links
              .map(
                (l) =>
                  `<a href="${l.href}" class="text-muted" style="font-size:var(--text-sm);">${l.text}</a>`
              )
              .join('')}
          </div>
        </div>
      </div>
    `;
    return footer;
  }
}
